import { AxiosError, AxiosInstance } from 'axios'

import { EndUser } from '@driftt/api-types'
import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'
import { CompanyData, ScoreBreakdown } from 'modules/accountActivity/domain'
import { captureExceptionWithMessage } from 'utils/logRocket'

const logErrorHandler = (error: AxiosError) => {
  captureExceptionWithMessage('Outbound Automation API Error', error, {
    url: window.location.href,
    endpoint: error.config.url,
    errorData: JSON.stringify(error.config)
  })
}

const responseErrorHandlers = [logErrorHandler]

export const EmailAutomationAPI: AxiosInstance = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.OUTBOUND_AUTOMATION_API
  }
})

export type AutomationAccountSummary = {
  accountId: string
  companyData: CompanyData
  companyName: string
  accountFitScore: number
  featureWeights: ScoreBreakdown
  engagementScore: number
  normalizedEngagementScore: number
  contactsEnrolled: number
  scheduledCount: number
  sentCount: number
  openCount: number
  clickCount: number
  replyCount: number
}

export type CadenceContact = {
  endUserId: number
  endUserData: EndUser
}

export const fetchAllAccountsEnrolled = (startTime: number, endTime: number) => {
  return EmailAutomationAPI.get(`/emails/summary?startTime=${startTime}&endTime=${endTime}`)
}

export const fetchUserAccountsEnrolled = (userId: string, startTime: number, endTime: number) => {
  return EmailAutomationAPI.get(
    `/emails/summary/byAgent/${userId}?startTime=${startTime}&endTime=${endTime}`
  )
}

export const fetchEmailsByAccountAndEvent = (
  accountId: string,
  eventType: string,
  startTime: number,
  endTime: number
) => {
  return EmailAutomationAPI.get(
    `/emails/byAccount/${accountId}/byEventType/${eventType}?startTime=${startTime}&endTime=${endTime}`
  )
}

export const fetchCadenceContactsByAccount = (
  accountId: string,
  startTime: number,
  endTime: number
) => {
  return EmailAutomationAPI.get(
    `/emails/contacts/byAccount/${accountId}?startTime=${startTime}&endTime=${endTime}`
  )
}
